import { useBookDemo } from "./BookDemoModal";

type FooterLink = { label: string; href?: string; action?: "book" };

const footerLinks: { title: string; links: FooterLink[] }[] = [
  {
    title: "Product",
    links: [
      { label: "Platform", href: "#platform" },
      { label: "Deployment", href: "#deploy" },
      { label: "COMPL-AI", href: "#complai" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Guides", href: "#resources" },
      { label: "FAQ", href: "#faq" },
      { label: "How to use", href: "#how" },
    ],
  },
  {
    title: "Company",
    links: [
      // Book a call opens the same demo/contact form as Book a demo.
      { label: "Book a call", action: "book" },
      { label: "Contact", href: "mailto:info@bridgeai.one" },
    ],
  },
];

export default function Footer() {
  const { openBookDemo } = useBookDemo();
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:max-w-xs">
            <p className="text-lg font-semibold text-foreground-950 mb-2">
              AI Compliance Checker
            </p>
            <p className="text-sm text-foreground-600">
              Article 50 evidence, on demand.
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8 lg:gap-10">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="text-xs font-semibold tracking-wide uppercase text-foreground-500 mb-3">
                  {col.title}
                </h4>
                <ul className="space-y-2">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      {link.action === "book" ? (
                        <button
                          type="button"
                          onClick={openBookDemo}
                          className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                        >
                          {link.label}
                        </button>
                      ) : (
                        <a
                          href={link.href}
                          className="text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                        >
                          {link.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-xs text-foreground-500">
            © 2026 AI Compliance Checker
          </span>
          <span className="text-xs text-foreground-500">
            EU AI Act · Article 50 · Deadline 2 Aug 2026
          </span>
        </div>
      </div>
    </footer>
  );
}